<template>
  <section
    class="
      mx-4
      my-4
      p-8
      text-center
      lg:ml-11
      text-gray-900
      bg-white bg-opacity-70
      rounded-3xl
      lg:relative
    "
  >
    <div class="lg:grid grid-cols-2 lg:gap-12">
      <div id="brandinfo" class="lg:flex flex-col items-center justify-center">
        <div id="brandtitle" class="mb-5 font-semibod text-base">
          <h4 class="font-bold text-4xl">Employment Services</h4>
        </div>
        <div id="text" class="mb-4 text-xl font-semibold leading-loose">
          <h2>Login Dashboard</h2>
          <p class="font-mono my-3 text-xs">
            Enter your Email ID and password below
          </p>
        </div>
      </div>
      <vee-form :validation-schema="schema" @submit="login">
        <div id="email" class="mb-2">
          <div class="form-control">
            <label class="label">
              <span class="label-text text-black font-semibold text-sm"
                >Email ID</span
              >
            </label>
            <vee-field
              name="Candidate_mailid"
              type="text"
              placeholder="Email Address"
              class="input input-bordered input-info"
            />
            <ErrorMessage class="text-red-600" name="Candidate_mailid" />
          </div>
        </div>
        <div id="password" class="mb-5">
          <div class="form-control">
            <label class="label">
              <span class="label-text text-black font-semibold text-sm"
                >Password</span
              >
            </label>
            <vee-field
              name="Password"
              :type="passowrdType"
              placeholder="Password"
              class="input input-bordered input-info"
            />
            <div class="flex items-end justify-end mt-3">
              <div class="form-control">
                <label class="cursor-pointer label" @click="showHidePass">
                  <span class="label-text mr-2">{{
                    showPass ? "Show Password" : "Hide Password"
                  }}</span>
                  <input type="checkbox" class="checkbox" />
                </label>
              </div>
            </div>
            <ErrorMessage class="text-red-600" name="Password" />
          </div>
        </div>
        <div id="button">
          <button
            :disabled="clicked"
            class="btn btn-info mb-5 hover:bg-blue-500 lg:w-96"
          >
            Login
          </button>
        </div>
        <div id="info" @click="currentState">
          <p class="font-semibold text-sm">
            Need a account?
            <span class="cursor-pointer link text-blue-600">SignUp</span>
          </p>
        </div>
      </vee-form>
      <div v-if="loginerror" class="lg:absolute lg:left-40 lg:right-12">
        <div class="modal-box">
          <p class="text-lg font-semibold leading-snug text-indigo-500">
            User name, Password does not exists, Try creating a new user
            account.
          </p>
          <div class="modal-action flex items-center justify-center">
            <button @click="errorLogin" class="btn btn-primary">Close</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { useRouter } from "vue-router";
export default {
  name: "Login",
  props: ["currentState"],
  data() {
    return {
      loginerror: false,
      clicked: false,
      passowrdType: "password",
      showPass: true,
      router: useRouter(),
      resdata: null,
      schema: {
        Candidate_mailid: "required|email",
        Password: "required",
      },
    };
  },
  methods: {
    showHidePass() {
      this.showPass = !this.showPass;
      this.passowrdType =
        this.passowrdType === "password" ? "text" : "password";
    },
    errorLogin() {
      this.loginerror = false;
    },
    login(values) {
      this.clicked = true;
      const jsondata = JSON.stringify(values);
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/loginuser`,
          jsondata
        )
        .then((res) => {
          if (res.data.Mill) {
            // sessionStorage.setItem("millId", res.data.Mill);
            // this.$store.commit("Mill/updateMillId");
            // this.router.push({ name: "MillDashboard" });
            this.router.push({ name: "UnderConstruction" });
          } else if (res.data.Candidate) {
            sessionStorage.setItem("id", res.data.Candidate);
            // this.$store.commit("updateId");
            this.$store.commit("Candidate/updateId");
            this.router.push({ name: "Dashboard" });
          }

          if (res.data == null) {
            this.loginerror = true;
          }
          this.clicked = false;
        })
        .catch((err) => {
          if (err) {
            this.loginerror = true;
            this.clicked = false;
          } else {
            this.loginerror = false;
            this.clicked = false;
          }
        });
    },
  },
};
</script>
